<div class="sp-dialog-shell">

  <div class="sp-dialog-header">
    <div class="sp-dialog-icon">
      <ion-icon [name]="data?.confirmText === 'Stop sharing' ? 'eye-off-outline' : 'share-social-outline'"></ion-icon>
    </div>
    <div class="sp-dialog-title-wrap">
      <h2 mat-dialog-title class="sp-dialog-title">{{ data?.title || 'Confirm action' }}</h2>
      <p class="sp-dialog-subtitle">Please review this change before continuing.</p>
    </div>
  </div>

  <mat-dialog-content class="sp-dialog-content">
    <p class="sp-dialog-message">{{ data?.message }}</p>
  </mat-dialog-content>

  <div class="sp-dialog-actions">
    <button mat-stroked-button type="button" class="sp-btn sp-btn-cancel" (click)="cancel()">
      Cancel
    </button>
    <button mat-flat-button type="button" color="primary" class="sp-btn sp-btn-confirm" (click)="confirm()">
      {{ data?.confirmText || 'Confirm' }}
    </button>
  </div>
</div>
